import { Typography } from '@mui/material';
import { memo } from 'react';
import LEDChart from '../../../components/common/LEDChart';

const WaterLevelChart = ({ title, data }) => {
	return (
		<>
			<Typography gutterBottom fontWeight={'bold'}>
				{title}
			</Typography>
			<Typography gutterBottom variant="body2">
				{data.Unit}
			</Typography>
			<LEDChart
				title={title}
				seriesName={data.Unit}
				upperLimit={
					data.WaterConduct >
						data.MaxAllowedConduct
						? data.WaterConduct + 10
						: data.MaxAllowedConduct + 10
				}
				middleLimit={data.MaxAllowedConduct}
				value={data.WaterConduct}
				unit={data.Unit}
			/>
		</>
	);
};

export default memo(WaterLevelChart);